module.exports = __webpack_public_path__ + "img/gamificacao.256c893a.png";